import axios from 'axios'
import { apiUrl } from '../config'
import authenticationStore from '../stores/authenticationStore'
import utils from '../utils'

export const BoardResolutionMinutesRequest = {
  createBoardResolutionMinutes: formData =>
    axios({
      method: 'post',
      url: `${apiUrl}/api/v1/board_resolution_minutes`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      data: {
        document_name: formData.document_name,
        document_number: formData.document_number,
        status: formData.status,
        issue_date: formData.issue_date,
        issue_level: formData.issue_level,
        contruction_board: formData.contruction_board,
        attachments_minutes: formData.attachments_minutes,
        attachments_resolution: formData.attachments_resolution,
      },
    }),
  updateBoardResolutionMinutes: (id, formData) =>
    axios({
      method: 'put',
      url: `${apiUrl}/api/v1/board_resolution_minutes/${id}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      data: {
        document_name: formData.document_name,
        document_number: formData.document_number,
        issue_date: formData.issue_date,
        ...(!utils.isNullish(formData.status) && { status: formData.status }),
        ...(!utils.isNullish(formData.issue_level) && {
          issue_level: formData.issue_level,
        }),
        ...(!utils.isNullish(formData.contruction_board) && {
          contruction_board: formData.contruction_board,
        }),
        attachments_minutes: formData.attachments_minutes || [],
        attachments_resolution: formData.attachments_resolution || [],
      },
    }),
  deleteBoardResolutionMinutes: id =>
    axios({
      method: 'delete',
      url: `${apiUrl}/api/v1/board_resolution_minutes/${id}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
    }),
  getBoardResolutionMinutes: params =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/board_resolution_minutes`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      params: {
        page: params.page - 1,
        size: params.size,
        ...(!utils.isNullish(params.document_name) && {
          document_name: params.document_name,
        }),
        ...(!utils.isNullish(params.document_number) && {
          document_number: params.document_number,
        }),
        ...(!utils.isNullish(params.from_issue_date) && {
          from_issue_date: params.from_issue_date,
        }),
        ...(!utils.isNullish(params.to_issue_date) && {
          to_issue_date: params.to_issue_date,
        }),
        ...(!utils.isNullish(params.status) && { status: params.status }),
        ...(!utils.isNullish(params.issue_level) && {
          issue_level: params.issue_level,
        }),
        ...(!utils.isNullish(params.contruction_board) && {
          contruction_board: params.contruction_board,
        }),
      },
    }),
  getBoardResolutionMinutesDetail: recordId =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/board_resolution_minutes/${recordId}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
    }),
  getAttachmentBoardHDQT: payload =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/board_resolution_minutes/${payload.recordId}/attachments/${payload.fileId}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      responseType: 'blob',
    }),
  getviewBoardFile: payload =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/board_resolution_minutes/${payload.recordId}/viewFile/${payload.fileId}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      responseType: 'arraybuffer',
    }),
}
